import { useCallback, useEffect, useState } from 'react';
import { noop } from 'lodash-es';

import api from '../api';
import { SCHEDULED_EXPORTS_LIMIT } from '../configs/constants';

function useScheduledExportsCount({ enabled = true } = {}) {
  const [isScheduledCountLoaded, setScheduledCountLoaded] = useState(false);
  const [scheduledExportsCount, setScheduledExportsCount] = useState(SCHEDULED_EXPORTS_LIMIT);

  const fetchScheduledExportsCount = useCallback(() => {
    if (!enabled) return;

    api
      .getScheduledExportsCount()
      .then(({ data }) => {
        setScheduledExportsCount(data.scheduled_exports_count);
        setScheduledCountLoaded(true);
      })
      .catch(() => {
        setScheduledExportsCount(SCHEDULED_EXPORTS_LIMIT);
      });
  }, [enabled]);

  useEffect(() => {
    fetchScheduledExportsCount();
  }, [fetchScheduledExportsCount]);

  if (!enabled) {
    return {
      scheduledExportsCount: 0,
      scheduleLimitReached: false,
      refetchScheduledExportsCount: noop,
    };
  }

  return {
    scheduledExportsCount,
    scheduleLimitReached: scheduledExportsCount >= SCHEDULED_EXPORTS_LIMIT,
    isScheduledCountLoaded,
    refetchScheduledExportsCount: fetchScheduledExportsCount,
  };
}

export default useScheduledExportsCount;
